module.exports = __webpack_public_path__ + "static/media/022.4ae867f0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/products/thumbs/022.jpg
// module id = 529
// module chunks = 0